module.exports = __webpack_public_path__ + "img/IMG_7189_L_Foamcore.fded0aca.jpg";